export const getReturnPath = (returnUrl?: string | null): string | null => {
  if (!returnUrl) return null;

  if (returnUrl.startsWith("http")) {
    try {
      const url = new URL(returnUrl);
      return url.pathname + url.search;
    } catch {
      return null;
    }
  }

  return returnUrl.startsWith("/") ? returnUrl : "/" + returnUrl;
};
